<div class="alert" [ngClass]="type">
    @if(heading) {
    <div class="heading" [innerHTML]="heading"></div>
    }
    <ng-content></ng-content>
</div>